<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_AzmoonMaharatDetail.id==0">فرم ثبت مرحله جدید آزمون مهارت
      '{{inner_AzmoonMaharat.title}}' </h5>
    <h5 class="card-title" *ngIf="inner_AzmoonMaharatDetail.id>0">فرم ویرایش مرحله '{{inner_AzmoonMaharatDetail.title}}'
    </h5>

    <form [formGroup]="AzmoonMaharatForm">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> عنوان </label>
          <input formControlName="title" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_title().valid && get_Form_title().touched"
            class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> تاریخ شروع </label>
          <input formControlName="startDate" type="text" class="form-control" #startDateInput
            placeholder="اینجا تایپ کنید ...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [dateInitValue]="false" [input]="startDateInput"></ng-persian-datepicker>
          <small *ngIf="!get_Form_startDate().valid && get_Form_startDate().touched"
            class="form-text text-muted MyErrorRedColor">تاریخ شروع را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> تاریخ پایان </label>
          <input formControlName="endDate" type="text" class="form-control" #endDateInput
            placeholder="اینجا تایپ کنید ...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [dateInitValue]="false" [input]="endDateInput"></ng-persian-datepicker>
          <small *ngIf="!get_Form_endDate().valid && get_Form_endDate().touched"
            class="form-text text-muted MyErrorRedColor">تاریخ پایان را وارد نمائید.</small>
        </div>
      </div>


    </form>

    <br />
    <hr />
    <br />

    <form [formGroup]="AzmoonMaharatFileForm">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> عنوان </label>
          <input formControlName="title" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_FormFile_title().valid && get_FormFile_title().touched"
            class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> فایل </label>
          <input #file_template (change)="UploadTemplate(file_template.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_FormFile_templateSrc().valid && get_FormFile_templateSrc().touched"
            class="form-text text-muted MyErrorRedColor">فایل را وارد نمائید.</small>
        </div>
      </div>

      <button *ngIf="!InProccessing" type="button" (click)="OnSubmitFile()" [disabled]="!AzmoonMaharatFileForm.valid"
        class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن فایل </button>
    </form>

    <br />
    <hr />
    <br />

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>عنوان</th>
            <th>فایل</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of FileDataLise">
           <td>{{FileDataLise.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>
              <a class="btn btn-danger" href="{{BaseUrl}}{{item.templateSrc}}" target="_blank">
                مشاهده فایل
              </a>
            </td>
            <td>
              <button (click)="RemoveFile(FileDataLise.indexOf(item))" type="button" class="btn btn-danger"> حذف </button>
            </td>

          </tr>
        </tbody>
      </table>
   </div>

   <br />
   <hr />
   <br />

   <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
   <button *ngIf="!InProccessing" type="button" (click)="OnSubmit()" [disabled]="!AzmoonMaharatForm.valid"
     class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
   <button (click)="onBack()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>



  </div>
</div>